import React, { memo } from 'react'
import { makeStyles, createStyles } from '@mui/styles'
import { Theme, Typography } from '@mui/material'

import SpecialInterestRate from '../special-interest-rate'
import { RATE_AFFIX } from '../../typings'
import { ISpecialInterestRate } from '../special-interest-rate/typings'
import { IBankRatesProps } from './typings'

const useStyles = makeStyles<Theme, ISpecialInterestRate>((theme: Theme) =>
  createStyles({
    rateTextCls: {
      fontSize: 20,
      fontWeight: 'bold',
      lineHeight: 1.1,
    },
    descriptionTextCls: {
      fontSize: 12,
      fontWeight: 400,
      color: theme.palette.grey[900],
      WebkitFontSmoothing: 'antialiased',
    },
    interestRateCls: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'end',
    },
    microTextCls: {
      fontSize: 9,
      color: theme.palette.grey[500],
      marginLeft: 5,
    },
  }),
)

const SpecialInterestRateContainer = ({
  rate,
  descriptionText,
  decorator,
  microText,
  specialInterestRate,
}: IBankRatesProps) => {
  const { descriptionTextCls, interestRateCls, microTextCls, rateTextCls } =
    useStyles(specialInterestRate || { isSpecial: false })
  const rateText =
    decorator.affix === RATE_AFFIX.PREFIX
      ? `${decorator.value}${rate}`
      : `${rate}${decorator.value}`

  return (
    <SpecialInterestRate
      isSpecial={specialInterestRate?.isSpecial || false}
      themeColors={specialInterestRate?.themeColors}
    >
      <span className={interestRateCls}>
        <Typography className={rateTextCls}>{rateText}</Typography>
        <Typography className={microTextCls}>
          bis {microText?.value}%*
        </Typography>
      </span>
      <Typography className={descriptionTextCls}>{descriptionText}</Typography>
    </SpecialInterestRate>
  )
}

export default memo(SpecialInterestRateContainer)
